<template>
  <div>
    <!-- PC的导航条-->
    <div  v-if="isPc"  :class="{'navBarWrap animated fadeIn': searchBarFixed}"  >
      <div class="menuClass flex-box-row" :class="{'animated fadeIn': !searchBarFixed}">
        <div style="width: 15%;text-align:right" class="flex-box-row">
          <!-- <el-image :src="require('../assets/images/logo2.png')" style="width:147px;height:34px" v-if="searchBarFixed" ></el-image>
          <el-image :src="require('../assets/images/logo1.png')" style="width:147px;height:34px" v-else ></el-image>
          &nbsp;
          <span class="font-22" :class="searchBarFixed? 'font-blue-color':'white-color'">江苏精益智控科技有限公司</span>  -->
        </div>
        <div style="width:85%"  class="pc-class flex-box-row-left">
         <div style="text-align:left;padding-top:12px" class="flex-box-row">
          <el-image :src="require('../assets/images/logo2.png')" style="width:280px;height:35px" v-if="searchBarFixed" ></el-image>
          <el-image :src="require('../assets/images/logo1.png')" style="width:280px;height:35px" v-else ></el-image>
          &nbsp;
        </div>
          <div class="flex-box-row flex-hearder" style="width:150px;height:75px;margin-left:40px">
            <div style="width:150px;height:50px;margin-top:25px">
                <router-link to="/" class="router-link-class underliner-class"  :class="searchBarFixed ? 'graycolor' : 'lightwhitecolor'"  :style="computedColor(1)" >首页</router-link> 
             </div>
          </div>
           <div class="flex-box-row flex-hearder" >
                <div style="width:150px;height:75px">
                 <div style="height:50px;margin-top:25px" class="flex-hearder">
                    <router-link to="/ProductCheck" class="router-link-class"  :class="searchBarFixed ? 'graycolor' : 'lightwhitecolor'" :style="computedColor(4)">产品及解决方案</router-link>&nbsp;<i class="fa fa-angle-down fa-lg" style="color:#b0b0b0"></i>
               </div>
               <div class="dropdown-menu" style="height:200px;width:560px">
                   <div style="display:flex">   <!-- 水平布局3列-->
                      <div  class="dropdown-menu-item flex-box-center">
                      <div class="bottom-son-class flex-box-center"  @click="btnDivJump('/ProductCheck')" style="margin-top:10px;width:180px; align-items:flex-start;padding-left:30px">
                        <div style="width:170px">
                             <router-link to="/product" class="bottom-link-class"><span class="font-16">端部尺寸检测设备</span></router-link>
                         </div>
                      </div>
                      <div  class="bottom-son-class flex-box-center" @click="btnDivJump('/ProductPolish')" style="width:180px;align-items:flex-start;padding-left:30px">
                         <div style="width:170px">
                           <router-link to="/ProductPolish" class="bottom-link-class"><span class="font-16">端部自动修磨设备</span></router-link>
                        </div> 
                      </div>
                       <div  class="bottom-son-class flex-box-center" @click="btnDivJump('/ProductInOut')" style="width:180px;align-items:flex-start;padding-left:30px">
                           <div style="width:170px">
                              <router-link to="/ProductInOut" class="bottom-link-class"><span class="font-16">内表面缺陷检测设备</span></router-link>
                          </div>
                        </div>
                       <div  class="bottom-son-class flex-box-center" @click="btnDivJump('/ProductPing')" style="width:180px;align-items:flex-start;padding-left:30px">
                             <div style="width:170px">
                              <router-link to="/ProductPing" class="bottom-link-class"><span class="font-16">平直度检测设备</span></router-link>
                          </div>
                         </div>
                      </div>
                      <div  class="dropdown-menu-item" style="width:160px" >
                        <div class="bottom-son-class flex-box-center"  @click="btnDivJump('/ProductTrack')" style="margin-top:10px;padding-left:20px">
                           <div style="width:150px">
                             <router-link to="/ProductTrack" class="bottom-link-class"><span class="font-16">物料逐支跟踪系统</span></router-link>
                           </div>
                         </div>
                      </div>
                       <div  class="dropdown-menu-item" style="width:160px">
                            <div class="bottom-son-class flex-box-center"  @click="btnDivJump('/ProductControl')"  style="margin-top:10px;padding-left:20px">
                             <div style="width:150px">
                                   <router-link to="/ProductControl" class="bottom-link-class"><span class="font-16">智能化集控中心</span></router-link>
                              </div>
                          </div>
                     </div>
                   </div>
                </div>
            </div>
          </div>
          <div class="flex-box-row flex-hearder" >
                <div style="width:150px;height:75px">
                 <div style="height:50px;margin-top:25px" class="flex-hearder">
                    <router-link to="/news" class="router-link-class"  :class="searchBarFixed ? 'graycolor' : 'lightwhitecolor'" :style="computedColor(3)"> 公司动态</router-link>&nbsp;<i class="fa fa-angle-down fa-lg" style="color:#b0b0b0"></i>
               </div>
               <div class="dropdown-menu" style="height:105px">
                    <div class="dropdown-menu-item flex-box-center" >
                      <div class="bottom-son-class flex-box-center" @click="btnDivJump('/news')" style="margin-top:10px">
                          <router-link to="/news" class="bottom-link-class"><span class="font-16">最新资讯</span></router-link>
                      </div>
                     <div  class="bottom-son-class flex-box-center" @click="btnDivJump('/NewsPersonCare')">
                        <router-link to="/NewsPersonCare" class="bottom-link-class"><span class="font-16">人文关怀</span></router-link>
                      </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="flex-box-row flex-hearder" >
             <div style="width:150px;height:75px">
                 <div style="height:50px;margin-top:25px" class="flex-hearder">
                      <router-link to="/about" class="router-link-class"  :class="searchBarFixed ? 'graycolor' : 'lightwhitecolor'" :style="computedColor(2)">关于我们</router-link>&nbsp;<i class="fa fa-angle-down fa-lg" style="color:#b0b0b0"></i>
                 </div>
                 <div class="dropdown-menu" style="height:195px">
                    <div class="dropdown-menu-item flex-box-center">
                      <div class="bottom-son-class flex-box-center" @click="btnDivJump('/about')" style="margin-top:10px;">
                          <router-link to="/about" class="bottom-link-class"><span class="font-16">公司简介</span></router-link>
                      </div>
                       <div  class="bottom-son-class flex-box-center" @click="btnDivJump('/CompanyHistory')">
                          <router-link to="/CompanyHistory" class="bottom-link-class"><span class="font-16">历史沿革</span></router-link>
                      </div>
                      <div class="bottom-son-class flex-box-center" @click="btnDivJump('/CompanyHonor')">
                          <router-link to="/CompanyHonor"  class="bottom-link-class"><span class="font-16">资质荣誉</span></router-link>
                      </div>
                      <!-- <div class="bottom-son-class flex-box-center" @click="btnDivJump('/CompanyStaff')">
                           <router-link to="/CompanyStaff" class="bottom-link-class"><span class="font-16">员工风采</span></router-link>
                      </div> -->
                       <div class="bottom-son-class flex-box-center" @click="btnDivJump('/CompanyCustomer')">
                           <router-link to="/CompanyCustomer" class="bottom-link-class"><span class="font-16">合作客户</span></router-link>
                      </div>
                  </div>
                </div>
             </div>
          </div>
           <div  class="flex-box-row flex-hearder" style="width:150px;height:75px;">
             <div style="width:150px;height:50px;margin-top:25px">
                 <router-link to="/contact" class="router-link-class underliner-class"  :class="searchBarFixed ? 'graycolor' : 'lightwhitecolor'" :style="computedColor(5)">联系我们</router-link>  
             </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 手机的导航条 -->
    <div :class="searchBarFixed ? 'navBarPhoneWrap' : ''" v-else>
      <div class="flex-box-between  phone-head-color phone-head-height" >
        <div style="widht: 80%">
             &nbsp; &nbsp;
             <el-image :src="require('../assets/images/logo1.png')" style="width:480px;height:60px" ></el-image>
          <!-- <span class="font-20 white-color p-shadow" >&nbsp; &nbsp;江苏精益智控</span> -->
        </div>
        <div style="width: 20%">
          <el-button   @click="btnShowMenu" type="text"><i class="fa fa-4x" :class="isShowPhoneMenu ? 'fa-arrow-left' : 'fa-th'" style="color:#fff"> </i></el-button>
        </div>
      </div>
     <el-drawer   direction="ltr"  class="el-drawer-class1"  :visible.sync="isShowPhoneMenu" :show-close="false"	size="70%" :modal-append-to-body="false" :withHeader="false">
       <div class="phone-class phone-drawer-class">
          <div class="animated fadeInUp" style="padding-top: 25px">
              <div class="flex-box-between" style="margin:0 20px 0 20px;height:150px">
                 <div> <router-link to="/" class="router-link-class" @click.native="menuClick"><i class="fa fa-home fa-fw"></i>首页</router-link></div>
              </div>
              <el-divider content-position="right"></el-divider>
              <div class="flex-box-between" style="margin:0 20px 0 20px;height:150px" @click="isActive1 = !isActive1; isActive2=false;isActive3=false">
                 <div> <router-link to="/news" class="router-link-class"><i class="fa fa-th-large fa-fw"></i> 公司动态</router-link></div>
                 <i class="fa fa-angle-down fa-3x" style="color:#fff"  v-if="isActive1" ></i>
                 <i class="fa fa-angle-right fa-3x" style="color:#fff" v-else ></i>
              </div>
              <div  v-show="isActive1" class="animated fadeIn" style="padding:0 0 0 20px;height:100px">
                  <div class="fadeIn flex-box-row">
                      <div style="width:50%" class="text-left"> <router-link to="/news" class="router-link-class" @click.native="menuClick"><span class="font-34"> 最新资讯</span></router-link></div>
                      <div style="width:50%" class="text-left"> <router-link to="/NewsPersonCare" class="router-link-class" @click.native="menuClick"><span class="font-34"> 人文关怀</span></router-link></div>
                  </div>
              </div>
              <el-divider content-position="right"></el-divider>
                 <div class="flex-box-between" style="margin:0 20px 0 20px;height:150px" @click="isActive2 = !isActive2 ; isActive1=false;isActive3=false">
                     <div> <router-link to="/news" class="router-link-class" ><i class="fa fa-wrench fa-fw"></i>产品及解决方案</router-link></div>
                       <i class="fa fa-angle-down fa-3x" style="color:#fff"  v-if="isActive2" ></i>
                      <i class="fa fa-angle-right fa-3x" style="color:#fff" v-else ></i>
                 </div>
                <div  v-show="isActive2" class="animated fadeIn" style="padding:0 0 0 20px;">
                    <div class="fadeIn flex-box-row" style="height:100px">
                          <div style="width:50%" class="text-left"> <router-link to="/ProductCheck" class="router-link-class"  @click.native="menuClick"><span class="font-34"> 管端尺寸检测</span></router-link></div>
                          <div style="width:50%" class="text-left"> <router-link to="/ProductPolish" class="router-link-class" @click.native="menuClick"><span class="font-34"> 管端自动修磨</span></router-link></div>
                    </div>
                     <div class="fadeIn flex-box-row" style="height:100px">
                          <div  style="width:50%" class="text-left"> <router-link to="/ProductInOut" class="router-link-class" @click.native="menuClick"><span class="font-34"> 内表面缺陷检测</span></router-link></div>
                          <div style="width:50%"  class="text-left"> <router-link to="/ProductPing" class="router-link-class"  @click.native="menuClick"><span class="font-34"> 平直度检测设备</span></router-link></div>
                    </div>
                    <div class="fadeIn flex-box-between" style="height:100px">
                         <div style="width:50%" class="text-left"> <router-link to="/ProductTrack" class="router-link-class"   @click.native="menuClick"><span class="font-34"> 物料逐支跟踪系统</span></router-link></div>
                         <div style="width:50%" class="text-left"> <router-link to="/ProductControl" class="router-link-class" @click.native="menuClick"><span class="font-34"> 智能化集控中心 </span></router-link></div>
                    </div>
              </div>
              <el-divider content-position="right"></el-divider>
                <div class="flex-box-between" style="margin:0 20px 0 20px;height:150px" @click="isActive3 = !isActive3 ;isActive2=false;isActive1=false">
                    <div> <router-link to="" class="router-link-class" ><i class="fa fa-user fa-fw"></i>关于我们</router-link></div>
                    <div>
                      <i class="fa fa-angle-down fa-3x" style="color:#fff"  v-if="isActive3" ></i>
                      <i class="fa fa-angle-right fa-3x" style="color:#fff" v-else ></i>
                    </div>
                 </div>
                <div  v-show="isActive3" class="animated fadeIn" style="padding:0 0 0 20px">
                    <div class="fadeIn flex-box-row" style="height:100px">
                        <div style="width:50%" class="text-left"> <router-link to="/about" class="router-link-class" @click.native="menuClick"><span class="font-34"> 公司简介</span></router-link></div>
                        <div style="width:50%" class="text-left"><router-link to="/CompanyHistory" class="router-link-class" @click.native="menuClick"><span class="font-34"> 历史沿革</span></router-link></div>
                    </div>
                    <div class="fadeIn flex-box-row" style="height:100px">
                        <div style="width:50%" class="text-left"> <router-link to="/CompanyHonor" class="router-link-class" @click.native="menuClick"><span class="font-34"> 资质荣誉</span></router-link></div>
                        <div  style="width:50%" class="text-left"> <router-link to="/CompanyCustomer" class="router-link-class" @click.native="menuClick"><span class="font-34"> 合作客户 </span></router-link></div>
                    </div>
              </div>
              <el-divider content-position="right"></el-divider>
               <div class="flex-box-between" style="margin:0 20px 0 20px;height:150px" >
                    <div> <router-link to="/contact" class="router-link-class" @click.native="menuClick" > <i class="fa fa-phone fa-fw"></i>联系我们</router-link></div>
                 </div>
                    <el-divider content-position="right"></el-divider>
            </div> 
          <!-- <button @click="isActive = !isActive">展开/折叠</button>
            <collapse> 
              <div class="container" v-show="isActive">
                    <h2>欢迎你们品尝Pizza!</h2>
                    <h5>这里有你很是喜欢的Pizza!</h5>
                </div>
            </collapse>   -->
          </div>
     </el-drawer>
    </div>
  </div>
</template>
<script>
import collapse from "../utils/collapse";

export default {
  data() {
    return {
      activeIndex: "/",
      searchBarFixed: false,
      isPc: true, //用来区分是否为手机端
      isShowPhoneMenu: false,
      isActive1:false,
      isActive2:false,
      isActive3:false,
    };
  },
  components: {
    collapse,
  },
  created() {
       this.isPc = this.$util.isPc();
       this.setCurrentRoute();
  },
  mounted() {
    window.addEventListener("scroll", this.watchScroll);
  },
  computed:{
   computedColor(){
    return (type)=>{
    if(type==1) 
      {
        if(this.activeIndex=="/")
         return  this.returnColor()
         else
         return ''
      }
      else if(type==2)
       {
        if(this.activeIndex=="/about" || this.activeIndex=="/CompanyHistory" || this.activeIndex=="/CompanyHonor" || this.activeIndex=="/CompanyStaff"|| this.activeIndex=="/CompanyCustomer")
           return  this.returnColor()
         else
         return ''
       }
       else if(type==3)
       {
          if(this.activeIndex=="/news"||this.activeIndex=="/NewsPersonCare")           
          return  this.returnColor()
         else
         return '' 
       }
      else if(type==4)
       {
         if(this.activeIndex=="/product"||this.activeIndex=="/ProductCheck"||this.activeIndex=="/ProductPolish"||this.activeIndex=="/ProductInOut"||this.activeIndex=="/ProductPing"||this.activeIndex=="/ProductTrack"||this.activeIndex=="/ProductControl")        
          return  this.returnColor()
         else
         return '' 
       }  
       else if(type==5)
       {
             if(this.activeIndex=="/contact")    
          return  this.returnColor()
         else
         return '' 
       }
      }
    }
  },
  methods: {
     returnColor(){
          return  (this.searchBarFixed==true ?  'color:#111;border-bottom-width:3px;border-bottom-style:solid;padding-bottom:17px' :  'color:#fff;border-bottom-width:3px;border-bottom-style:solid;padding-bottom:17px')
     },
     btnDivJump(url){
           this.$router.push({
            path:url
       })
    },
    btnShowMenu() {
      this.isShowPhoneMenu = !this.isShowPhoneMenu;
    },
    menuClick() {
      //点击后要折叠起来
      this.isShowPhoneMenu = false;
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    setCurrentRoute() {
      this.activeIndex = this.$route.path; //通过他就可以监听到当前路由状态并激活当前菜单
    },
    watchScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  当滚动超过 50px 时，实现吸顶效果(滚动条高度当前设置为：50px)
      if (scrollTop > 49) {
        this.searchBarFixed = true;
      } else {
        this.searchBarFixed = false;
      }
    }
  },
  watch: {
    $route() {
      this.setCurrentRoute();
    }
  }
};
</script>
<style scoped>

.graycolor{
    color:rgba(55, 55, 55, 0.6);  /*a标签颜色 */
    border-bottom-color:#409eff; /*下划线颜色 */
}
.lightwhitecolor{
   color:rgba(255, 255, 255, 0.6); /*a标签颜色 */
   border-bottom-color:#FFF;   /*下划线颜色 */
}

.dropdown-menu{
  list-style-type:none;
  border-radius:5px;
  box-shadow:0px 0px 13px rgb(237 240 243);
  background-clip:padding-box;
  background-color:#fff;
  min-width: 180px;
  height: 220px;
  text-align:left;
  left:-15px;
  top:-15px;
  position:relative;
   display : none;
}
.bottom-son-class
{
  /* text-align:center; */
  width:100%;
  height:40px;
  padding-top:5px;
}
.pc-class .flex-hearder:hover ~ .dropdown-menu{   /*媒体中心鼠标悬浮*/
     display : block;
}

.pc-class  .dropdown-menu:hover {   /*媒体中心鼠标悬浮(向上移动了10像素)*/
     display : block;
}

.phone-head-height{
  height: 100px;
}
.phone-head-color {
  /* background-color: #26263a; */
  background-color: #38567E;
}

.el-menu-demo el-menu--horizontal el-menu {
  padding-left: none !important;
}


.navBarWrap {
  position: fixed;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 75px;
  z-index: 9;
  box-shadow:rgb(0 0 0 / 20%) 0px 0px 10px; 
  transition: all 1s ease-in-out;    
   animation-duration:1s ;  
}

.menuClass {
  position: absolute;
  /* top: 20px; */
  width: 100%;
  height: 75px;
  z-index: 8;
  transition: all 1s ease-in-out;
}

.navBarWrapOut {  /*隐藏动画*/
     background: transparent;
   transition: all 1s ease-in-out;
   z-index: 9;
}

.navBarPhoneWrap {
  position: fixed;
  top: 0;
  background-color: #fff;
  width: 100%;
  height: 100px;
  z-index: 9;
}

.divmenubottom{
  position: absolute;
  top: 75px;
  width: 100%;
  z-index: 9;
   background-color: #c9dbda;
   height: 150px;
   display: none;
   border-radius: 5px;
}



.pc-class   {
  /* margin-left: 30%; */
   height: 75px;
}

.pc-class .router-link-class{
  text-decoration: none;
  /*color: rgba(55, 55, 55, 0.6);向下出现的颜色变成灰色rgba(55, 55, 55, 0.6)，向上吸顶时变成白色rgba(255, 255, 255, 0.6)*/
  font-size: 18px;
  margin-left: 5%;
  height: 60px;
}

.pc-class .bottom-link-class{
  text-decoration: none;
   color: #333333;  
  font-size: 16px;
  height: 30px;
}

.pc-class .flex-hearder:hover .underliner-class{ /*鼠标悬停加下划线*/
       /* color: #409eff;  */
       /* text-decoration: underline;   */
      /* border-bottom:3px solid #fff; */
       border-bottom-width:3px; 
       border-bottom-style:solid;
      padding-bottom:17px;
} 

 .dropdown-menu-item  div:hover   {
      background-color: #f4f7fa;
 }
 .bottom-son-class  :hover   {
      color: #409eff;   
 }
 

/*鼠标悬浮*/
.pc-class :hover   {
  cursor: pointer;
}
 
.divmenubottom:hover  {
  display : block;
}
 

.phone-drawer-class {
    /* background-color: #2F4052;  */
    background-color: #38567E;
   height: 100%;  
}
 
.phone-class a {
  text-decoration: none;
  color: #fff;
  font-size: 36px;
   
}
 
/* .pc-class .router-link-active {
 
  font-family: -apple-system, SF UI Display, Arial, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, WenQuanYi Micro Hei, sans-serif;
} */
 
.el-drawer-class{
   background-color:#2F4052 ;  
 
}
</style>